import { computed } from 'vue';
import { useI18n, usePlanLimits } from '@/composables';
import { useStore } from '@/store';
type FlowSettingsForm = {
  name?: string;
  countryId?: number;
  tags?: unknown[];
  workspaceId?: string;
};

type FlowSettingsProps = {
  form: FlowSettingsForm;
};

export const useFlowSettings = (props: FlowSettingsProps) => {
  const store = useStore();
  const { t } = useI18n();
  const tagsPlanLimits = usePlanLimits('tagsFlows');

  const countryListPlusGlobal = computed(() => store.countryListPlusGlobal);

  const countryName = computed(() => {
    if (!props.form.countryId) return '';
    return (
      countryListPlusGlobal.value?.find((item) => item.id === props.form.countryId)?.name || ''
    );
  });

  const nameDescription = computed(() => {
    const countryLabel = countryName.value || t('Global');
    const nameLabel = props.form.name || t('None');
    return `${countryLabel} - ${nameLabel}`;
  });

  const showPlanLimitsWarningTags = computed(
    () => Boolean(props.form.tags?.length) && tagsPlanLimits.hasPlanLimitsRestriction('tagsFlows'),
  );

  const clearTags = () => {
    props.form.tags = [];
  };

  return {
    t,
    store,
    countryListPlusGlobal,
    nameDescription,
    showPlanLimitsWarningTags,
    clearTags,
  };
};
